const shippingMethodTypes = [
  'homeDelivery',
  'pickUp',
  'intangible',
  'novios'
] as const;
type TShippingMethodType = (typeof shippingMethodTypes)[number];

const homeDeliveryServiceNames = [
  'SCHEDULED',
  'NEXT_DAY',
  'SAME_DAY',
  'DATE_RANGE',
  'SCHEDULED_DEFERRED'
] as const;
type THomeDeliveryServiceName = (typeof homeDeliveryServiceNames)[number];

const pickupDeliveryServiceNames = ['COLLECT'] as const;
type TPickupDeliveryServiceName = (typeof pickupDeliveryServiceNames)[number];

type TShippingEngineDeliveryServiceName =
  | THomeDeliveryServiceName
  | TPickupDeliveryServiceName;

type TEngineDelivery =
  | TEngineHomeDelivery
  | TEnginePickUp
  | TEngineIntangible
  | TEngineNovios;

type TEngineHomeDelivery =
  | TEngineHomeDateRangeDelivery
  | TEngineHomeExpressDelivery
  | TEngineHomeSameDayDelivery
  | TEngineHomeScheduledDelivery
  | TEnginePickUpCopec;

type TEngineHomeScheduledDelivery = {
  shippingMethodServiceName?: typeof HOME_DELIVERY_SERVICE_NAMES.SCHEDULED;
  type: typeof SHIPPING_METHOD_TYPE.HOME_DELIVERY;
  id: string;
  name: string;
  label: string;
  description: number | string;
  preSale: boolean;
  marketPlace: boolean;
  express: boolean;
  sameDay: boolean;
  shippingMethodServiceRequest: boolean;
  active: boolean;
  priority: number;
  shippingMethodsConstantName: string;
  orderPriorityForUI: number;
  isStandardModeOn: boolean;
};

type TEngineHomeDateRangeDelivery = {
  shippingMethodServiceName?: typeof HOME_DELIVERY_SERVICE_NAMES.DATE_RANGE;
  type: typeof SHIPPING_METHOD_TYPE.HOME_DELIVERY;
  id: string;
  name: string;
  label: string;
  description: number | string;
  preSale: boolean;
  marketPlace: boolean;
  express: boolean;
  sameDay: boolean;
  shippingMethodServiceRequest: boolean;
  active: boolean;
  priority: number;
  shippingMethodsConstantName: string;
  orderPriorityForUI: number;
  isStandardModeOn: boolean;
};

type TEngineHomeSameDayDelivery = {
  shippingMethodServiceName?: typeof HOME_DELIVERY_SERVICE_NAMES.SAME_DAY;
  type: typeof SHIPPING_METHOD_TYPE.HOME_DELIVERY;
  id: string;
  name: string;
  label: string;
  description: number | string;
  preSale: boolean;
  marketPlace: boolean;
  express: boolean;
  sameDay: boolean;
  shippingMethodServiceRequest: boolean;
  active: boolean;
  priority: number;
  shippingMethodsConstantName: string;
  orderPriorityForUI: number;
  isStandardModeOn: boolean;
};

type TEngineHomeExpressDelivery = {
  shippingMethodServiceName?: typeof HOME_DELIVERY_SERVICE_NAMES.EXPRESS;
  type: typeof SHIPPING_METHOD_TYPE.HOME_DELIVERY;
  id: string;
  name: string;
  label: string;
  description: number | string;
  preSale: boolean;
  marketPlace: boolean;
  express: boolean;
  sameDay: boolean;
  shippingMethodServiceRequest: boolean;
  active: boolean;
  priority: number;
  shippingMethodsConstantName: string;
  orderPriorityForUI: number;
  isStandardModeOn: boolean;
};

type TEnginePickUp = {
  type: typeof SHIPPING_METHOD_TYPE.PICK_UP;
  shippingMethodServiceName?: TPickupDeliveryServiceName;
  id: string;
  name: string;
  label: string;
  description: number | string;
  preSale: boolean;
  marketPlace: boolean;
  express: boolean;
  sameDay: boolean;
  shippingMethodServiceRequest: boolean;
  active: boolean;
  priority: number;
  shippingMethodsConstantName: string;
  orderPriorityForUI: number;
  isStandardModeOn: boolean;
};
type TEngineIntangible = {
  type: typeof SHIPPING_METHOD_TYPE.INTANGIBLE;
  id: string;
  name: string;
  label: string;
  description: number | string;
  preSale: boolean;
  marketPlace: boolean;
  express: boolean;
  sameDay: boolean;
  shippingMethodServiceRequest: boolean;
  active: boolean;
  priority: number;
  shippingMethodsConstantName: string;
  orderPriorityForUI: number;
  isStandardModeOn: boolean;
};
type TEngineNovios = {
  type: typeof SHIPPING_METHOD_TYPE.NOVIOS;
  id: string;
  name: string;
  label: string;
  description: number | string;
  preSale: boolean;
  marketPlace: boolean;
  express: boolean;
  sameDay: boolean;
  shippingMethodServiceRequest: boolean;
  active: boolean;
  priority: number;
  shippingMethodsConstantName: string;
  orderPriorityForUI: number;
  isStandardModeOn: boolean;
};

type TEnginePickUpCopec = {
  type: typeof SHIPPING_METHOD_TYPE.PICKUP_COPEC;
  id: string;
  name: string;
  label: string;
  shippingMethodServiceName: THomeDeliveryServiceName | null;
  description: number | string;
  preSale: boolean;
  marketPlace: boolean;
  express: boolean;
  sameDay: boolean;
  shippingMethodServiceRequest: boolean;
  active: boolean;
  priority: number;
  shippingMethodsConstantName: string;
  orderPriorityForUI: number;
  isStandardModeOn: boolean;
  seller: string | null;
  thirdPickUpPointType: string | null;
};

const SHIPPING_METHOD_TYPE = {
  HOME_DELIVERY: 'homeDelivery',
  PICK_UP: 'pickUp',
  INTANGIBLE: 'intangible',
  PICKUP_COPEC: 'homeDelivery',
  NOVIOS: 'novios'
} as const;

const HOME_DELIVERY_SERVICE_NAMES = {
  SCHEDULED: 'scheduled',
  DATE_RANGE: 'daterange',
  SAME_DAY: 'sameday',
  EXPRESS: '24hours',
  PICKUP_COPEC: 'pickupCopec'
} as const;

export { SHIPPING_METHOD_TYPE, shippingMethodTypes };
export type {
  TEngineDelivery,
  TEngineHomeDelivery,
  TEngineIntangible,
  TEngineNovios,
  TEnginePickUp,
  THomeDeliveryServiceName,
  TPickupDeliveryServiceName,
  TShippingEngineDeliveryServiceName,
  TShippingMethodType
};
